import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'
import { getGroupEmployees } from '../../../services'
import { Loader2 } from 'lucide-react'

// Fetches and renders employees for a Keycloak group
const GroupEmployeesTable: React.FC<{ groupId: string }> = ({ groupId }) => {
    const { data, isLoading } = useQueryWithHandler({
        queryKey: [
            QUERY_KEYS.AUTHORIZATION_POLICIES,
            'group-employees',
            groupId,
        ],
        queryFn: () => getGroupEmployees(groupId),
    })

    if (isLoading) {
        return (
            <div className="flex items-center gap-1.5 py-2 text-xs text-muted-foreground">
                <Loader2 className="h-3 w-3 animate-spin" />
                <span>Đang tải...</span>
            </div>
        )
    }

    const employees = data?.results || []

    if (employees.length === 0) {
        return (
            <span className="text-xs text-muted-foreground">
                Không có thành viên
            </span>
        )
    }

    return (
        <table className="w-full text-xs border-collapse">
            <thead>
                <tr className="bg-muted/50">
                    <th className="text-left p-1.5 border font-medium">
                        Username
                    </th>
                    <th className="text-left p-1.5 border font-medium">
                        Nhân viên
                    </th>
                    <th className="text-left p-1.5 border font-medium">
                        Mã NV
                    </th>
                    <th className="text-left p-1.5 border font-medium">
                        Email
                    </th>
                    <th className="text-left p-1.5 border font-medium">SĐT</th>
                </tr>
            </thead>
            <tbody>
                {employees.map((emp) => (
                    <tr key={emp.keycloakId}>
                        <td className="p-1.5 border">{emp.username}</td>
                        <td className="p-1.5 border">
                            {emp.employeeName || (
                                <span className="text-muted-foreground italic">
                                    {[emp.firstName, emp.lastName]
                                        .filter(Boolean)
                                        .join(' ') || '—'}
                                </span>
                            )}
                        </td>
                        <td className="p-1.5 border font-mono">
                            {emp.employeeCode || '—'}
                        </td>
                        <td className="p-1.5 border text-muted-foreground">
                            {emp.employeeEmail || emp.email || '—'}
                        </td>
                        <td className="p-1.5 border text-muted-foreground">
                            {emp.employeePhoneNumber || '—'}
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    )
}

export default GroupEmployeesTable
